/** Recognizes fetch failures in native and SDK-normalized form; cancellation stays terminal. */
export function isSupabaseTransportFailure(error: unknown, status?: number): boolean {
  if (!error || typeof error !== 'object') return false;

  const fields = error as Record<string, unknown>;
  const code = typeof fields.code === 'string' ? fields.code : '';
  const name = typeof fields.name === 'string' ? fields.name : '';
  const message = typeof fields.message === 'string' ? fields.message : '';
  const hint = typeof fields.hint === 'string' ? fields.hint : '';
  const details = typeof fields.details === 'string' ? fields.details : '';
  const describesFetchFailure =
    /failed to fetch|fetch failed|networkerror|network error|load failed/i.test(message);
  const wasAborted =
    name === 'AbortError' ||
    code === 'ABORT_ERR' ||
    /^AbortError:/i.test(message) ||
    /\babort(?:ed)?\b/i.test(hint) ||
    /^AbortError:/i.test(details);

  if (wasAborted || code !== '') return false;
  if (status !== undefined) return status === 0 && describesFetchFailure;
  return error instanceof TypeError && describesFetchFailure;
}
